<template>
  <div class="md-layout">
    <div
      class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100"
    >
      <md-toolbar class="md-primary">
        <h3 class="md-title">{{ $t("Checklist") }}</h3>
      </md-toolbar>
      <br />
    </div>

    <div
      class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100"
    >
      <md-card v-blur="blur">
        <md-card-header class="md-card-header-text md-card-header-primary">
          <div class="card-text" style="display: block;background: grey;">
            <h4 class="title">{{ $t("Checklist List") }}</h4>
          </div>
        </md-card-header>
        <md-card-content>
          <md-table class="paginated-table table-striped table-hover">
            <md-table-head>ID</md-table-head>
            <md-table-head>{{ $t("Name") }}</md-table-head>
            <md-table-head>{{ $t("Language") }}</md-table-head>
            <md-table-head>{{ $t("Edit") }}</md-table-head>
            <md-table-row
              v-for="(item, position) in checklists"
              :key="position"
            >
              <md-table-cell md-label="ID">{{ position + 1 }}</md-table-cell>
              <md-table-cell :md-label="$t('Name')">{{
                position > 1 ? item.name : $t("Default")
              }}</md-table-cell>
              <md-table-cell :md-label="$t('Language')">{{
                item.language
                  ? item.language === "fr"
                    ? $t("French")
                    : $t("English")
                  : ""
              }}</md-table-cell>
              <md-table-cell>
                <md-button
                  v-if="
                    position < checklists.length - 1 ||
                      (($store.state.auth.usertype === USER_TYPE.PRO ||
                        $store.state.auth.usertype === USER_TYPE.MAAC) &&
                        position === checklists.length - 1 &&
                        checklists.length <= 4) ||
                      (($store.state.auth.usertype === USER_TYPE.ADMIN ||
                        $store.state.auth.usertype === USER_TYPE.ENTERPRISE ||
                        $store.state.auth.usertype === USER_TYPE.SUPER) &&
                        position === checklists.length - 1)
                  "
                  class="md-just-icon md-simple md-primary"
                  @click="showChecklistEditor(position)"
                >
                  <md-icon v-if="item.lock">visibility</md-icon>
                  <md-icon v-else>create</md-icon>
                </md-button>
                <md-button
                  style="margin-left: 10px;"
                  v-if="item.type === CHECKLIST_TYPE.REVIEWER && item.language === LANGUAGE.EN"
                  class="md-just-icon md-simple md-primary"
                >
                  <a target="blank" :href="flightReviewRubricUrl"
                    ><md-icon>picture_as_pdf</md-icon></a
                  >
                </md-button>
              </md-table-cell>
            </md-table-row>
          </md-table>
        </md-card-content>
      </md-card>
      <modal v-if="editingChecklist">
        <template slot="header">
          <md-button
            class="md-simple md-just-icon md-round modal-default-button"
            @click="closeChecklistEditor"
          >
            <md-icon>clear</md-icon>
          </md-button>
        </template>

        <template slot="body">
          <h4
            v-if="this.positionChecklist <= 1"
            class="title text-primary text-left"
            style="text-align:left;"
          >
            {{
              this.checklists[this.positionChecklist].name
                ? this.checklists[this.positionChecklist].name
                : $t("Default")
            }}
            ({{ this.checklists[this.positionChecklist].language }})
          </h4>
          <div v-else>
            <md-field>
              <label>{{ $t("Name") }}</label>
              <md-input
                name="name"
                data-vv-name="name"
                v-model="name"
                required
                v-validate="'required|min:3'"
                type="text"
                :disabled="lock"
              ></md-input>
            </md-field>
            <div style="text-align:left">
              <md-radio :disabled="lock" v-model="language" :value="LANGUAGE.EN">{{
                $t("English")
              }}</md-radio>
              <md-radio :disabled="lock" v-model="language" :value="LANGUAGE.FR">{{
                $t("French")
              }}</md-radio>
            </div>
          </div>
          <div style="margin-top: 20px; max-height:600px; text-align:left;">
            <collapse
              :parent="this.checklist"
              :collapse="this.checklist"
              :noCollapse="true"
              color-collapse="primary"
              :disabled="lock"
            >
              <template
                v-for="(section, s_index) in this.checklist"
                :slot="'md-collapse-pane-' + (s_index + 1)"
              >
                <collapse
                  :key="s_index"
                  :collapse="section.items"
                  icon="keyboard_arrow_up"
                  :noCollapse="false"
                  color-collapse="primary"
                  :disabled="lock"
                >
                  <template
                    v-for="(item, i_index) in section.items"
                    :slot="'md-collapse-pane-' + (i_index + 1)"
                  >
                    <md-radio
                      :key="'radio_checkbox_' + s_index + '_' + i_index"
                      style="margin: 0"
                      v-model="item.verbal"
                      :value="false"
                      :disabled="lock"
                      >{{ $t("Checkbox") }}</md-radio
                    >
                    <md-radio
                      :key="'radio_verbal_' + s_index + '_' + i_index"
                      style="margin: 0 0 0 10px"
                      v-model="item.verbal"
                      :value="true"
                      :disabled="lock"
                      >{{ $t("Verbal") }}</md-radio
                    >
                    <md-field
                      :key="'description_' + s_index + '_' + i_index"
                      style="margin:0"
                    >
                      <label>{{ $t("Description") }}</label>
                      <md-textarea
                        :disabled="lock"
                        v-model="item.description"
                        >{{ item.description }}</md-textarea
                      >
                    </md-field>
                  </template>
                </collapse>
              </template>
            </collapse>
          </div>
        </template>
        <template slot="footer" v-if="!lock">
          <md-button
            v-if="
              !this.checklists[this.positionChecklist].name &&
                this.positionChecklist <= 1
            "
            class="md-primary md-simple"
            @click="restoreDefault"
          >
            {{ $t("Restore Default") }}
          </md-button>
          <md-button class="md-primary md-simple" @click="addSection">
            {{ $t("Add a section") }}
          </md-button>
          <md-button
            v-if="this.positionChecklist === this.checklists.length - 1"
            class="md-success md-simple"
            @click="addChecklist"
            >{{ $t("Save") }}</md-button
          >
          <md-button
            v-else
            class="md-success md-simple"
            @click="editChecklist"
            >{{ $t("Save") }}</md-button
          >
          <md-button
            v-if="this.positionChecklist > 1"
            class="md-danger md-simple"
            @click="deleteChecklist"
            >{{ $t("Delete") }}</md-button
          >
        </template>
      </modal>
    </div>
  </div>
</template>

<script>
import { Modal, Collapse } from "@/components";
import { router } from "@/main";
import swal from "sweetalert2";
import { USER_TYPE, CHECKLIST_TYPE, LANGUAGE } from "@/const.js";
import { EventBus, FLIGHT_REVIEW_URL } from "@/helpers";
import { downloadFile } from "@/helpers/utils";

export default {
  $_veeValidate: {
    validator: "new"
  },
  components: {
    Modal,
    Collapse
  },
  data() {
    return {
      checklist: null,
      checklists: [],
      USER_TYPE: USER_TYPE,
      CHECKLIST_TYPE,
      LANGUAGE,
      editingChecklist: false,
      positionChecklist: 0,
      name: "",
      language: LANGUAGE.EN,
      lock: false
    };
  },
  computed: {
    blur: function() {
      return this.editingChecklist;
    },
    flightReviewRubricUrl() {
      return FLIGHT_REVIEW_URL + '/FlightReviewRubric.pdf';
    }
  },
  watch: {
    "$store.state.checklist": {
      handler: async function(newVal) {
        this.checklists = JSON.parse(JSON.stringify(newVal.checklists));
      },
      deep: true
    }
  },
  methods: {
    onResponsiveInverted() {
      if (window.innerWidth < 768) {
        this.responsive = true;
      } else {
        this.responsive = false;
      }
    },
    showChecklistEditor(position) {
      this.positionChecklist = position;
      var sections = this.checklists[position].sections;
      sections.forEach(section => {
        section.lock = false;
        for (var i = 0; i < section.items.length; i++) {
          if (section.items[i].lock) {
            section.lock = true;
            break;
          }
        }
        section.items.forEach(item => {
          item.verbal = item.verbal ? true : false;
        });
      });
      this.name = this.checklists[position].name;
      this.language = this.checklists[position].language;
      this.lock = this.checklists[position].lock;
      this.checklist = [...sections];
      this.editingChecklist = true;
    },
    closeChecklistEditor() {
      this.editingChecklist = false;
    },
    restoreDefault() {
      this.$store.dispatch("checklist/restore", {
        language: this.checklists[this.positionChecklist].language
      });
    },
    addSection() {
      this.checklist.push({
        title: this.$t("new section"),
        items: []
      });
    },
    addChecklist() {
      this.$store.dispatch("checklist/add", {
        language: this.language,
        name: this.name,
        sections: this.checklist
      });
    },
    editChecklist() {
      this.$store.dispatch("checklist/edit", {
        position: this.positionChecklist,
        language: this.language,
        name: this.name,
        sections: this.checklist
      });
    },
    deleteChecklist() {
      this.$store
        .dispatch("checklist/delete", this.positionChecklist)
        .then(() => {
          this.editingChecklist = false;
        });
    }
  },
  beforeMount() {
    if (
      this.$store.state.auth.usertype === USER_TYPE.PILOT ||
      this.$store.state.auth.usertype === USER_TYPE.FREE
    ) {
      swal
        .fire({
          title: this.$t("Warning"),
          text: this.$t(
            "Only administrator can access Checklist Template Editor page!"
          ),
          type: "warning",
          confirmButtonClass: "md-button md-warning",
          buttonsStyling: false
        })
        .then(() => {
          router.push("/dashboard");
        });
    } else {
      if (!this.$store.state.checklists) {
        this.$store.dispatch("checklist/getChecklists");
      }
    }
  },
  mounted() {
    EventBus.$on("setChecklists", () => {
      // if (this.editingChecklist) {
      //   this.showChecklistEditor(this.positionChecklist);
      // }
    });

    this.onResponsiveInverted();
    window.addEventListener("resize", this.onResponsiveInverted);
  },
  beforeDestroy() {
    EventBus.$off("setChecklists");
    window.removeEventListener("resize", this.onResponsiveInverted);
  }
};
</script>

<style lang="css">
.modal-container {
  max-width: 800px;
}
</style>
